module.exports = "/_next/static/images/CustomizeData-894e8e24445a4e2c365a027bb390cbc2.webp";